import { TFn, MenuItem } from "./types";
import { buildGeneralSettings } from "./generalSettings";
import { buildApplications } from "./applications";
import { buildPeripherals } from "./peripherals";

export function buildMenu(
    t: TFn,
    foodCourt: boolean,
    isDefault: boolean
): MenuItem[] {
    return [
        buildGeneralSettings(t, foodCourt, isDefault),
        buildApplications(t, isDefault),
        buildPeripherals(t),
    ];
}

export function menuItems(t: TFn, foodCourt: boolean): MenuItem[] {
    return buildMenu(t, foodCourt, true);
}

export function menuItemsDefaultSetting(
    t: TFn,
    foodCourt: boolean
): MenuItem[] {
    return buildMenu(t, foodCourt, false);
}
